import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

/* Config */
import config from "./app/config.json";

/* Views */
import Landing from "./features/landing/Landing";
import Profile from "./features/profile/Profile";
import LoginCallback from "./features/auth/LoginCallback";

/* Components */
import AppNavbar from "./features/navbar/Navbar";

/* APIs - Utils*/
import { PrivateOutlet } from "./utils/components/PrivateOutlet";
import { useCsrfPingMutation } from "./features/auth/authApi";
import { toastQueryError } from "./utils/toasts";

function App() {
  let didSendPing = false;
  const [csrfPing, { isError, error }] = useCsrfPingMutation();

  useEffect(() => {
    if (!didSendPing) {
      csrfPing();
      didSendPing = true;
    }
  }, []);

  useEffect(() => {
    if (error) {
      toastQueryError(error);
    }
  }, [isError, error]);

  return (
    <>
      <ToastContainer />
      <AppNavbar />
      <Routes>
        <Route path={config.urls.home.url} element={<Landing />} />
        <Route
          path={config.urls.auth.loginCallback.url}
          element={<LoginCallback />}
        />
        <Route path={config.urls.user.profile.url} element={<PrivateOutlet />}>
          <Route index element={<Profile />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
